// extracted by mini-css-extract-plugin
export var container = "_2n-0";
export var icon = "_2n-1";